
export default {
  props: {
    question: String,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toId(value) {
      if (!value) return "";
      return value
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(/[^\w-]+/g, "") // Remove all non-word chars
        .replace(/--+/g, "-"); // Replace multiple - with single -
    },
  },
};
